import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ParametrosConst} from 'src/app/util/parametrosConst';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {
  constructor() {
  }

  intercept(req, next): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const token = localStorage.getItem(ParametrosConst.TOKEN);
    const authReq = req;
    if (token != null) {
      const request = req.clone({
        setHeaders: {
          authorization: `${token}`
        }
      });
      return next.handle(request);
    }
    return next.handle(authReq);
  }
}
